<div class="card h-100">
  <div class="card-body d-flex align-items-center">
    <div class="flex-shrink-0 me-3">
      @if (icon) {
        <div class="d-flex align-items-center justify-content-center rounded-3"
             [ngClass]="'bg-' + iconColor + ' bg-opacity-10 text-' + iconColor"
             style="width: 48px; height: 48px;">
          <i [class]="icon + ' fa-lg'"></i>
        </div>
      }
    </div>
    <div class="flex-grow-1">
      <span class="text-muted small d-block">{{ title }}</span>
      <h5 class="mb-0 fw-bold" [ngClass]="'text-' + iconColor">{{ value }}</h5>
      @if (subtitle) {
        <span class="text-muted small">{{ subtitle }}</span>
      }
    </div>
  </div>
</div>
